module.exports = __webpack_public_path__ + "static/media/home-placeholder.d388b38d.png";